import M_ENV from '../../../../main/components/env/index.js'

// dom节点数据转参数
const _domTransferParams = (node) => {
    // dom节点参数
    let dom_params = {
        offset_x: '', // 位置信息
        offset_y: '', // 位置信息
        time_stamp: '', // 时间戳
        class_name: '', // 样式类名
        dataset: '', // data参数
        id: '', // 元素ID
        inner_text: '', // 文案
        inner_html: '', // 文案结构
        tag_name: '' // 标签名称
    }
    // data埋点参数
    let data_params = {
        event_pos: '',
        event_pos_name: '',
        isc: '',
        event_case_code: '',
        event_type: node.event_type,
        report_source: node.report_source
    }
    if (M_ENV.isWeexNativeInApp) {
        // 原生节点
        const { position, target, timestamp } = node
        const { attr, type } = target
        dom_params.offset_x = position.x
        dom_params.offset_y = position.y
        dom_params.time_stamp = timestamp
        dom_params.dataset = attr
        dom_params.id = attr.id
        dom_params.inner_text = attr.value
        dom_params.tag_name = type

        data_params.event_pos = attr['dataLxEventPos'] || node.event_pos || ''
        data_params.event_pos_name = attr['dataLxEventPosName'] || node.event_pos_name || '' 
        data_params.isc = attr['dataLxIsc'] || node.isc || ''
        data_params.event_case_code = attr['dataLxEventCaseCode'] || node.event_case_code || ''
    } else {
        // h5节点
        const { className, dataset, id, innerText, innerHTML, tagName } = node.target
        dom_params.offset_x = node.offsetX || ''
        dom_params.offset_y = node.offsetY || ''
        dom_params.time_stamp = node.timeStamp
        dom_params.class_name = className
        dom_params.dataset = JSON.stringify(dataset)
        dom_params.id = id
        dom_params.inner_text = innerText
        dom_params.inner_html = innerHTML
        dom_params.tag_name = tagName

        data_params.event_pos = dataset['lxEventPos'] || node.event_pos || ''
        data_params.event_pos_name = dataset['lxEventPosName'] || node.event_pos_name || '' 
        data_params.isc = dataset['lxIsc'] || node.isc || ''
        data_params.event_case_code = dataset['lxEventCaseCode'] || node.event_case_code || ''
    }
   
    return { dom_params, data_params }
}

// dom节点数据处理
const handle = (params) => {
    const { event_params, origin_params } = params
    
    // 节点分析
    let { dom_params, data_params} = _domTransferParams(origin_params)
    // event_params.fix_element_type = dom_params.tag_name
    event_params.fix_element_name = dom_params.inner_text

    return { 
        origin_params: { ...data_params, dom_params },
        event_params
    }
    
}

export default {
    handle
}